import { render } from "./QPR.vue?vue&type=template&id=653b35a8"
import script from "./QPR.vue?vue&type=script&lang=js"
export * from "./QPR.vue?vue&type=script&lang=js"
script.render = render

export default script